//import jwtDecode from 'jwt-decode';
//import moment from 'moment';
import React, { createContext, useState } from 'react';
import { helpHttp } from '../helpers/helpHttp';
import { BASE_API } from '../api/Globals';
import { storage } from '../helpers/storage';

const AuthContext = createContext({});

const initialAuth = false;

const initialName = null;

const initialTipoUsuario = "";

const initialCiclo = "";

const AuthProvider = ({ children }) => {

    const [auth, setAuth] = useState(initialAuth);
    const [name, setName] = useState(initialName);
    const [nameTipoUsuario, setNameTipoUsuario] = useState(initialTipoUsuario);
    const [tienda, setTienda] = useState(initialTipoUsuario);
    const [nameCiclo, setNameCiclo] = useState(initialCiclo);


    const handleCloseSesion = () => {

        storage.clearEnv();
        handleCloseAuth();

        //window.location.replace('/#/login'); //Pendiente Luis Jorge 20/07/2023
    }

    const handleAuth = (e, token) => {
        setAuth(true);
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "spdTipoUsuariosObtener",
                tipo: 0,
                parametros: [
                    { idTipoUsuario: e.IdTipoUsuario }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            const nameTipo = res.ITEMS.find(x => x.code === e.IdTipoUsuario);
            storage.set('nombreTipoUsuario', nameTipo.name);
            setNameTipoUsuario(nameTipo.name)

        })
        storage.set('auth', true);
        storage.set('token', token);
        //window.localStorage.setItem('fechaxp', e.fechaxp);
        storage.set('id', e.IdUsuario);
        storage.set('IdTienda', e.IdTienda);
        storage.set('perfilid', e.IdTipoUsuario);
        storage.set('name', e.Nombre) //+ " " + e.Tienda);


        storage.set('usuario', e.Usuario);
        storage.set('tienda', e.Tienda);

        setName(`${e.Nombre} ${e.Tienda}`)



        // Falta regresar el valor para setearlo al topbar
    }

    const handleCiclo = (ciclo) => {
        storage.set('ciclo', ciclo)
        setNameCiclo(ciclo.Descripcion)
    }

    const handleCloseAuth = () => {
        setAuth(false);
    }

    const refreshName = () => {
        setName(storage.get('name'));
        setNameTipoUsuario(storage.get('nombreTipoUsuario'));
        setTienda(storage.get('tienda'));
        storage.get('ciclo') !== null ? setNameCiclo(storage.get('ciclo').Descripcion) : setNameCiclo(initialCiclo)
    }

    const getEnv = () => {
        // usa la misma lógica que tu helper
        return window.location.pathname.split('/')[1] || 'DEV';
    };

    const verifyExp = () => {
        const currentEnv = getEnv();
        const previousEnv = sessionStorage.getItem('current_env');

        if (previousEnv && previousEnv !== currentEnv) {
            console.log('Cambio de entorno:', previousEnv, '→', currentEnv);

            sessionStorage.clear(); // 🔥 limpia todo
        }

        sessionStorage.setItem('current_env', currentEnv);

        refreshName();
    }
    const data = { auth, name, tienda, nameTipoUsuario, nameCiclo, handleAuth, handleCloseAuth, refreshName, verifyExp, handleCloseSesion, setAuth, handleCiclo };

    return (
        <AuthContext.Provider value={data}>{children}</AuthContext.Provider>
    )
}

export { AuthProvider }
export default AuthContext;